module.exports = __webpack_public_path__ + "static/media/favorite-things.ec9a83bb.svg";